import React, { useState } from "react";
import CardBase from "@/components/cards/CardBase";
import { Button } from "@/components/ui/button";
import { useTypesDataContext } from "@/providers/TypesDataProvider";
import { useSimplifiedUserData } from "@/providers/SimplifiedUserDataProvider";
import TypeCreator from "./TypeCreator";
import TypeList from "./TypeList";

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface TypesWidgetProps {
  showTitle?: boolean;
  title?: string;
  backgroundColor?: string;
}

export default function TypesWidget({
  showTitle = true,
  title = "Types",
  backgroundColor,
}: TypesWidgetProps) {
  const { t } = usePlatformTranslation();
  const { selectedGame } = useSimplifiedUserData();
  const { types, isLoading, refreshTypes } = useTypesDataContext();

  // Types state
  const [isAddingType, setIsAddingType] = useState(false);

  // No need to group types anymore

  if (!selectedGame) {
    return (
      <CardBase backgroundColor={backgroundColor}>
        <div className="flex items-center justify-center h-32">
          <p className="text-gray-500">{t('platform.cards.widgets.please_select_a_game_to_manage_types')}</p>
        </div>
      </CardBase>
    );
  }

  return (
    <CardBase
      backgroundColor={backgroundColor}
      className="h-full flex flex-col"
      style={{
        maxHeight: "calc(100vh - 200px)",
        minHeight: "calc(100vh - 200px)",
      }}
    >
      {/* Sticky Header */}
      {showTitle && (
        <div className="sticky top-0 z-10 bg-background border-b border-input px-4 py-4 flex-shrink-0">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
              {title}
            </h3>
            <Button
              onClick={() => setIsAddingType(true)}
              disabled={isAddingType}
              size="sm"
              variant="default"
              tooltip="Create a new type"
              className="flex justify-center items-center gap-2 "
            >
              Create Types
            </Button>
          </div>
        </div>
      )}

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="space-y-4 p-4">
          {/* Type Creator Component */}
          <TypeCreator
            isOpen={isAddingType}
            onClose={() => setIsAddingType(false)}
            onSuccess={() => {
              // Refresh types data to show newly created type
              refreshTypes();
            }}
          />

          {/* Type List Component */}
          <TypeList
            types={types}
            isLoading={isLoading}
            onRefresh={refreshTypes}
          />
        </div>
      </div>
    </CardBase>
  );
}
